import React, { useState } from 'react'
import { getRoute } from '@pmi/pmi-iqos-shared-react'
import { ProductCardGeneric } from '@dcx-common/components'

const CardBundle = ({
  bundle,
  translations,
  loading,
  noDetailLink,
  onAddToCart,
  bundleDetailPath,
  ...rest
}) => {
  const [isAddingToCart, setIsAddingToCart] = useState(0)

  const handleAddToCart = async () => {
    setIsAddingToCart(1)
    onAddToCart && (await onAddToCart(bundle))
    setIsAddingToCart(0)
  }

  const { id, image, name, description, price, currency, badge, listPrice } =
    bundle

  return (
    <ProductCardGeneric
      handleAddToCart={handleAddToCart}
      id={id}
      images={[image]}
      title={name}
      description={description}
      alternativeBadge={badge}
      price={price}
      listPrice={listPrice}
      currency={currency}
      translations={translations}
      loading={isAddingToCart || loading}
      stock
      href={
        noDetailLink || !bundleDetailPath
          ? null
          : bundle.specialPath
          ? bundle.specialPath
          : getRoute(bundleDetailPath + id, true)
      }
      testingPrefix="ProductBundleList"
      {...rest}
    />
  )
}

export default CardBundle
